import { FC } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { PostAdd as PostAddIcon } from "@mui/icons-material";
import { canUseOnboardingRequests } from "../../../../auth/permissions";
import { useRoles } from "../../../../auth/useRoles";

export const MyBrokerRequestsMenu: FC = () => {
  const roles = useRoles();
  const showOnboardingRequests = canUseOnboardingRequests(roles);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2
      }}
    >
      <Typography sx={{ marginLeft: 1 }} variant="h5" component="span">
        My requests
      </Typography>
      {showOnboardingRequests && (
        <Link to="/brokers/request-new">
          <Button variant="outlined" startIcon={<PostAddIcon />}>
            Request
          </Button>
        </Link>
      )}
    </Box>
  );
};
